<template>
  <div>
    <text-des :value="textObj" :title="'考试介绍'" @changeText="changeText">
      <span slot="title"> <span class="titlemenu">考试介绍</span></span>
      <span slot="append"></span>
    </text-des>
    <div class="mt-4">
      <span class="titlemenu mt-4">考试科目</span
      ><span class="title-append">通过这门考试的科目，科目可以拖动排序</span>
    </div>

    <draggable
      v-model="rateList"
      @update="datadragEnd"
      :options="{ animation: 500 }"
    >
      <!--   <transition-group name="myfade"> -->
      <exam-course
        @upLoad="courseChange"
        class="mt-4"
        v-for="(item, index) in rateList"
        :key="index"
        :value="item"
        :index="index"
      />
      <!-- </transition-group> -->
    </draggable>
    <div v-show="rateList && rateList.length === 0" style="max-height: 150px">
      <!-- <el-empty
        v-show="rateList && rateList.length === 0"
        description="暂无数据"
      ></el-empty> -->
      <el-empty :image-size="50"></el-empty>
    </div>
    <span @click="addCourse" class="i-icon mt-4"
      ><i class="el-icon-plus"></i>科目</span
    >

    <div class="mt-4">
      <span class="titlemenu mt-4">关于我们</span
      ><span class="title-append"
        >可添加学习群的二维码，二维码可以拖动排序</span
      >
    </div>
    <!-- <input
      style="position: absolute; z-index: 999; opacity: 0; top: -10000px"
      ref="imginp"
      type="file"
      name="默认"
      id="img_input"
    /> -->
    <span @click="addCode" class="i-icon mt-4"
      ><i class="el-icon-plus"></i>二维码</span
    >
    <!-- 二维码区域 -->
    <div v-show="qList && qList.length === 0" style="max-height: 150px">
      <!-- <el-empty
        v-show="rateList && rateList.length === 0"
        description="暂无数据"
      ></el-empty> -->
      <el-empty :image-size="50"></el-empty>
    </div>
    <div id="qrcode">
      <draggable
        style="display: flex"
        v-model="qList"
        @update="datadragEnd"
        :options="{ animation: 500 }"
      >
        <transition-group name="myfade">
          <q-code
            style="display: inline-block"
            @deleteD="deleteD"
            class="qrcode_item"
            v-for="(item, index) in qList"
            :key="item.content"
            :value="item"
          />
        </transition-group>
      </draggable>
    </div>
    <Confirm @savePage="saveData" />
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";
import draggable from "vuedraggable";
import ue2 from "@/components/common/UE2.vue";
import RichText from "../components/RichText.vue";
import ExamCourse from "../components/ExamCourse.vue";
import TextDes from "../components/TextDes.vue";
import QCode from "../components/QCode.vue";
import Confirm from "../components/Confirm.vue";
import commonMixin from "../mixin/index.js";
export default {
  props: {
    /*  value: {
      type: Object,
    }, */
    com: {
      tyoe: String,
      default: "",
    },
  },
  mixins: [commonMixin],
  components: { draggable, ue2, RichText, ExamCourse, TextDes, QCode, Confirm },
  data() {
    return {
      allow: true,
      title: "考试介绍",
      list: [
        {
          title: "考试科目",
          content: "",
          anotherContent: "",
        },
      ],
      rateList: [
        /* {
          title: "考试科目",
          content: "34",
          anotherContent: "",
        }, */
      ], //评分
      qList: [], //二维码
      textObj: { title: "考试介绍", content: "" }, //富文本s
      dataObj: {
        courseList: [
          { id: 1, value: 1, title: "测试" },
          { id: 2, value: 3, title: "测试2" },
        ],
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    deleteD(content) {
      const index = this.qList.findIndex((obj) => obj.content === content);
      this.qList.splice(index, 1);
    },
    addCode() {
      const input = document.createElement("input");
      input.type = "file";
      input.name = this.fileName;
      input.accept = "image/gif,image/jpeg,image/jpg,image/png,image/svg";
      input.onchange = this.onFileChange;
      input.click();
    },
    /*选择上传图片切换*/
    onFileChange(e) {
      var fileInput = e.target;
      if (fileInput.files.length === 0) {
        return;
      }
      console.log("fileInput.files[0]", fileInput.files[0]);
      if (!fileInput.files[0].type.includes("image")) {
        return this.$message.error("必须上传图片类型文件");
      }
      if (fileInput.files[0].size > 1024 * 1024 * 2) {
        return this.$message.error("图片不能大于2M", "图片尺寸过大");
      }
      this.uploadFilePic(fileInput.files[0]);
    },
    // 上传图片到服务器
    uploadFilePic: function (imgSource) {
      console.log(imgSource);

      let formData = new FormData();
      formData.append("file", imgSource);
      console.log(formData);
      this.api.uploadFile(formData).then((res) => {
        if (res.success) {
          console.log(res.data);
          this.qList.push({ title: "关于我们", content: res.data });
        } else {
          this.$message.error("图片上传失败");
        }
      });
    },
    changeText(obj) {
      // debugger;
      // console.log("最外层", obj);
      this.textObj = obj;
      this.savePage();
    },
    savePage() {
      // console.log(this.rateList, "this.rateList");
      if (this.list.length > 0 && this.allow) {
        this.$emit("change", {
          type: this.com,
          subjectGuideItemDetails: [
            this.textObj,
            ...this.list,
            ...this.rateList,
          ],
        });
        this.allow = false;
      } else {
        this.$emit("change", {
          type: this.com,
          subjectGuideItemDetails: [
            this.textObj,
            ...this.rateList,
            ...this.qList,
          ],
        });
      }
    },
    courseChange(courseObj, bol, idx) {
      console.log("list", this.list);
      // console.log("course传来的数据", courseObj);
      let content = courseObj.content;
      /* let index = this.rateList.findIndex((obj) => obj.content === content); */
      if (bol) {
        this.rateList.splice(idx, 1);
        //return;
      } else {
        this.$set(this.rateList, idx, courseObj);
      }

      this.savePage();
    },
    /*  let content = courseObj.content;

      if (bol) {
        this.rateList.splice(idx, 1);
        return;
      }
      this.rateList[idx] = courseObj;
    }, */
    //添加
    addCourse() {
      this.rateList.push({
        title: "考试科目",
        content: "",
        anotherContent: 0,
      });

      //this.savePage();
    },
    //拖拽
    datadragEnd(list) {
      console.log(this.rateList);
      //this.savePage();
    },
    divide(list) {
      //富文本
      this.textObj = list.find((obj) => obj.title === "考试介绍") || {
        title: "考试介绍",
        content: "",
      };

      //评分数组
      this.rateList = list.filter((obj) => obj.title === "考试科目");
      //二维码
      this.qList = list.filter((obj) => obj.title === "关于我们");
    },
  },
  watch: {
    value: {
      handler(val) {
        //console.log("传值改变了", val);
        const list = val.subjectGuideItemDetails;
        /* //富文本
        this.textObj = list.find((obj) => obj.title === "考试介绍") || {
          title: "考试介绍",
          content: "",
        };
        //debugger;
        //评分数组
        this.rateList = list.filter((obj) => obj.title === "考试科目");
        //二维码
        this.qList = list.filter((obj) => obj.title === "关于我们"); */
        this.divide(list);
        // console.log(this.qList, val, "1221");
      },
      deep: true,
      immediate: true,
    },
    qList: {
      handler(list) {
        console.log(list, this.qList, "qlist");

        this.savePage();
      },
      deep: true,
      immediate: true,
    },
    rateList: {
      handler(list) {
        this.savePage();
      },
      deep: true,
      immediate: true,
    },
    list: {
      handler(list) {
        /* //富文本
        this.textObj = list.find((obj) => obj.title === "考试介绍");
        //debugger;
        //评分数组
        this.rateList = list.filter((obj) => obj.title === "考试科目");
        //二维码
        this.qList = list.filter((obj) => obj.title === "关于我们"); */
        this.divide(list);
        this.savePage();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  created() {},
  mounted() {
    /*  this.$nextTick(() => {
      if (this.type === "add") {
        this.addCourse();
        console.log("新增空的", this.rateList);
        this.$forceUpdate();
        // debugger;
      }
    }); */
  },
};
</script>
<style scoped>
#qrcode {
  /* display: flex; */
  margin-top: 1rem;
}

.qrcode_item {
  display: inline-block;
  margin-right: 5rem;
}

.myfade-enter-active,
.myfade-leave-active {
  transition: all 0.2s ease-out;
}

/* 进场的瞬间与离场的效果添加 */
.myfade-enter,
.myfade-leave-to {
  opacity: 0;
  transform: translateX(200px);
}

.titlemenu {
  font-weight: 600;
  font-size: 16px;
}

.title-append {
  margin-left: 1rem;
  color: #a5a5a5;
}

.mt-4 {
  margin-top: 1rem;
}

.i-icon {
  font-size: 16px;
  display: inline-block;
  color: #66b1ff;
  cursor: pointer;
}

.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}

.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.table_bottom {
  margin: 20px 0;
}

.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}

.campusManage-search {
  padding: 0px 10px;
}

.campusManage-tree {
  margin-top: 10px;
}

.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/module/testInstructions.vue